import React from 'react';
import { FormattedMessage } from 'react-intl';
import GoogleCalendar from 'containers/GoogleCalendar/GoogleCalendarContainer';
import OutlookCalendar from 'containers/OutlookCalendar/OutlookCalendarContainer';
import classes from './IntegrationSettings.module.scss';

const IntegrationSettings = () => (
  <div className={classes.container}>
    <header>
      <h1>
        <FormattedMessage id="settings.notification.sync" defaultMessage="Integration Settings" />
      </h1>
    </header>
    <div className={classes.settingsBody}>
      <div className={classes.meetingTitle}>
        <FormattedMessage id="components.integrationSettings.notifications" defaultMessage="Meeting Notifications" />
      </div>
      <div className={classes.meetingInstruction}>
        <FormattedMessage
          id="components.integrationSettings.notificationInstructions"
          defaultMessage="Add your calendar to receive notifications for upcoming meetings."
        />
      </div>
      <GoogleCalendar />
      <OutlookCalendar />
    </div>
  </div>
);

export default IntegrationSettings;
